import { useState } from "react";
import { useContext } from "react";
import { FrictionLogContext } from "@/data/FrictionLogContext";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { useToast } from "@/hooks/use-toast";

interface Props {
  contractorId: string;
  currentTab: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ReportProblemDialog({ contractorId, currentTab, open, onOpenChange }: Props) {
  const friction = useContext(FrictionLogContext);
  const [message, setMessage] = useState("");
  const { toast } = useToast();

  const handleSubmit = () => {
    const trimmed = message.trim();
    if (!trimmed) return;
    try {
      friction?.addEntry({
        id: `cf-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
        userId: contractorId,
        userRole: "subcontractor",
        moduleName: "Contractor Portal",
        screenName: currentTab,
        frictionType: "Bug",
        description: trimmed,
        severity: "Medium",
        status: "New",
        createdAt: new Date().toISOString(),
      });
      toast({ title: "Thanks — we got it.", description: "Our team will review your report." });
    } catch {
      /* fail silently */
    }
    setMessage("");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="report-problem-dialog" className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>Report a problem</DialogTitle>
        </DialogHeader>
        <Textarea
          data-testid="report-problem-input"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="What's not working?"
          rows={4}
        />
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button
            data-testid="report-problem-submit"
            onClick={handleSubmit}
            disabled={!message.trim()}
          >
            Send
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
